// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';

import { TextField } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';

export function FieldArgentineCbu(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();

  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('argentineCbu');

  const [document, handleChange] = useUserInputAsTextField('argentineCbu');

  return (
    <div data-test-name="argentine-cbu">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <label htmlFor={inputId}>CBU (Clave Bancaria Uniforme)</label>
      </div>
      <TextField
        id={inputId}
        type="tel"
        value={document}
        onChange={handleChange}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        readOnly={submitting}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="argentine-cbu"
      />

      {formHasBeenSent && validationError && (
        <ValidationErrorMessage validationError={validationError} />
      )}
    </div>
  );
}

type ValidationErrorMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return <ErrorLabel>El cbu es requerido</ErrorLabel>;
    case 'invalid-cbu':
      return <ErrorLabel>El cbu informado es inválido</ErrorLabel>;

    default:
      return <ErrorLabel>El cbu informado es inválido</ErrorLabel>;
  }
}
